import {
  array,
  boolean,
  number,
  object,
  string,
  type infer as zInfer,
} from "zod";

export const putControlPortIntegration = {
  name: "putControlPortIntegration" as const,
  input: object({
    apiKey: string().optional(),
    createReturnsEnabled: boolean(),
    processReturnsEnabled: boolean(),
    returnReasonMap: array(
      object({
        redoReason: string(),
        controlPortReasonId: number(),
        controlPortReasonName: string(),
      }),
    ),
    defaultReturnReasonId: number().nullable(),
  }),
  output: object({}),
};

export type PutControlPortIntegrationInput = zInfer<
  typeof putControlPortIntegration.input
>;
